import './Home.css';

export default function Home() {
  return (
    <section id="home">
      <div className="hero-inner">

        <div className="hero-text">
          <div className="hero-badge">Available for opportunities</div>

          <h1 className="hero-name">
            Camila<br />Sandoval
          </h1>

          <p className="hero-title">Senior Full-Stack Engineer</p>

          <p className="hero-desc">
            Building distributed systems, event-driven architectures, and AI-powered
            products. 5+ years shipping production software.
          </p>

          <div className="hero-actions">
            <a href="mailto:csandoval.eng@gmail.com">
              <button className="btn-primary">Get in Touch →</button>
            </a>
            <a href="#experience">
              <button className="btn-secondary">View Work</button>
            </a>
          </div>

          <div className="hero-stats">
            <div>
              <div className="hero-stat-value">5+</div>
              <div className="hero-stat-label">Years exp.</div>
            </div>
            <div>
              <div className="hero-stat-value">15+</div>
              <div className="hero-stat-label">Microservices owned</div>
            </div>
            <div>
              <div className="hero-stat-value">2026</div>
              <div className="hero-stat-label">Hackathon winner</div>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="terminal-card">
            <div className="terminal-bar">
              <div className="t-dot red" />
              <div className="t-dot yellow" />
              <div className="t-dot green" />
              <div className="terminal-title">camila.profile.ts</div>
            </div>
            <div className="terminal-body">
              <div className="t-line">
                <span className="t-prompt">$</span>
                <span className="t-cmd">cat profile.json</span>
              </div>
              <div className="t-output">
                <div><span className="t-key">"role"</span>: <span className="t-val">"Senior Full-Stack Engineer"</span>,</div>
                <div><span className="t-key">"location"</span>: <span className="t-val">"Fort Lauderdale, FL"</span>,</div>
                <div><span className="t-key">"stack"</span>: [</div>
                <div style={{paddingLeft:'16px'}}><span className="t-val">"NestJS"</span>, <span className="t-val">"TypeScript"</span>,</div>
                <div style={{paddingLeft:'16px'}}><span className="t-val">"React"</span>, <span className="t-val">"AWS"</span>, <span className="t-val">"Kafka"</span></div>
                <div>],</div>
                <div><span className="t-key">"ai"</span>: <span className="t-val accent">"RAG · Bedrock · Anthropic"</span></div>
              </div>
              <div className="t-line" style={{marginTop: '8px'}}>
                <span className="t-prompt">$</span>
                <span className="t-cursor" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
